import { render } from "./Specialist.vue?vue&type=template&id=1a8d5fa6&scoped=true"
import script from "./Specialist.vue?vue&type=script&lang=js"
export * from "./Specialist.vue?vue&type=script&lang=js"

import "./Specialist.vue?vue&type=style&index=0&id=1a8d5fa6&scoped=true&lang=scss"

import exportComponent from "D:\\work\\ocs\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a8d5fa6"]])

export default __exports__